<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <a href="https://cabcard.services">CabCard Services</a>
          </li>
          <li>
            <a href="https://cabcard.services/support">Support</a>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">&copy; 2019 CabCard Services Limited</div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
